export const ROUTES_MAPPINGS = {
  "/app/invalid-access": "INVALID_ACCESS",
  "/app/invalid-login": "INVALID_LOGIN",
  "/app/map-clinic-and-city": "MAPPED_CLINIC_AND_CITY",
  "/": "LANDING_PAGE",
  "/app": "ROOT",
  "/app/vms-setup": "VMS_SETUP",
  "/app/login": "LOGIN_PAGE",
  "/app/logout": "LOGOUT_PAGE",
  "/app/dashboard": "DASHBOARD",
  "/app/customer/profile": "CUSTOMER_PROFILE",
  "/app/customer/profile/vms-support": "CUSTOMER_SUPPORT",
  // Customer Profile Sub Pages
  "/app/customer/profile/search": "SEARCH_CUSTOMER",
  "/app/customer/profile/add": "ADD_CUSTOMER",
  "/app/customer/profile/user-level-coupon": "USER_LEVEL_COUPON",
  "/app/customer/profile/customer-details": "DETAILS_CUSTOMER",
  "/app/customer/profile/customer-create-emr": "CUSTOMER_EMR",
  "/app/customer/profile/emr-view": "EMR_PDF_VIEW",

  //New EMR Template
  "/app/customer/profile/create-emr": "EMR_CREATION",
  "/app/customer/profile/create-emr-bilable": "EMR_CREATION_BILABLE",

  // Customer Details Tabs
  "/app/customer/profile/customer-details/other-information": "OTHER_INFORMATION_TAB",
  "/app/customer/profile/customer-details/vaccination": "VACCINATION_TAB",
  "/app/customer/profile/customer-details/medicine-history": "MEDICINE_HISTORY",
  "/app/customer/profile/customer-details/reminder": "REMINDERS_TAB",
  "/app/customer/profile/customer-details/reminder-creation": "REMINDERS_CREATION",
  "/app/customer/profile/customer-details/reminder/action-cta-add-reminder": "ADD_REMINDER_ACTION_BUTTON",
  "/app/customer/profile/customer-details/appointments": "APPOINTMENTS_TAB",
  "/app/customer/profile/customer-details/EMR": "EMR_TAB",
  "/app/customer/profile/customer-details/lab-test": "LAB_TEST_TAB",
  "/app/customer/profile/customer-details/lab-interpretation": "LAB_INTERPRETATION_TAB",
  "/app/customer/profile/customer-details/certificates": "CERTIFICATES_TAB",
  "/app/customer/profile/customer-details/print-certificates": "PRINT_CERTIFICATES",
  "/app/customer/profile/customer-details/upload-certificates": "UPLOAD_CERTIFICATES",
  "/app/customer/profile/customer-details/activity": "ACTIVITY_TAB",
  "/app/customer/profile/customer-details/account": "ACCOUNT_TAB",
  "/app/customer/profile/customer-details/invoice": "INVOICE_TAB",
  "/app/customer/profile/customer-details/ticket": "TICKECT_TAB",
  "/app/customer/profile/customer-details/form-tab": "FORM_TAB",
  "/app/customer/profile/customer-details/membership-details": "MEMBERSHIP_DETAILS_TAB",

  // Customer Details Actions Routes
  "/app/customer/profile/customer-details/edit-pet": "EDIT_PET",
  "/app/customer/profile/customer-details/add-pet": "ADD_PET",
  "/app/customer/profile/customer-details/edit-customer": "EDIT_CUSTOMER",
  "/app/customer/profile/customer-details/manual-crt-control-panel": "MANUAL_CONTROL_PANEL_BUTTON",
  // Customer details tab ends here
  "/app/patient-waiting-list": "PATIENT_WAITING_LIST",
  "/app/at-home-services": "AT_HOME_SERVICES",
  "/app/qc-orders-a": "ORDER_MANAGEMENT_ACTION",
  "/app/qc-orders-r": "RX_ORDERS",
  "/app/qc-orders-qt": "QC_TRANSFER_ORDERS",
  //APPOINTMENTS overbooking
  "/app/appointment": "APPOINTMENTS",
  "/app/appointment/over-booking-permision-list": "OVER_BOOKING_PERMISION_LIST",
  "/app/appointment/overbooking-v2": "OVERBOOKING_V2",
  "/app/appointment/overbooking-v2/create": "OVERBOOKING_V2",
  "/app/appointment/overbooking-v2/update": "OVERBOOKING_V2",
  "/app/appointment/overbooking": "OVERBOOKING",
  "/app/appointment/check-slots": "CHECK_SLOTS",
  "/app/appointment/check-prices": "CHECK_PRICES",
  "/app/appointment/check-slots/check-booked-slots": "CHECK_BOOKED_SLOTS",
  "/app/appointment/check-slots/check-available-slots": "CHECK_AVAILABLE_SLOTS",
  "/app/appointment/preferred-doctors": "PREFERRED_DOCTORS",
  "/app/appointment/haircut-to-bath": "HAIRCUT_TO_BATH",
  "/app/appointment/shift-appointment": "APPOINTMENT_SHIFT",
  "/app/appointment/chargeable-bookings-list": "CHARGEABLE_BOOKING_LIST",
  "/app/appointment/product-requirement-form": "PRODUCT_REQUIREMENT_FORM",
  // Slot page
  "/app/slots": "SLOTS",
  "/app/slots/available-slots": "AVAILABLE_SLOTS",
  "/app/slots/booking-confirmation": "BOOKING_CONFIRMATION",
  "/app/slots/booking-details": "BOOKING_DETAILS",
  // SLots tabs
  "app/slots/available-slots": "AVAILABLE_SLOTS",
  "app/slots/booked-slots": "BOOKED_SLOTS",
  "app/slots/overbooking": "OVERBOOKING_SLOTS",
  "/app/slots/booked-slots": "BOOKED_SLOTS",
  "/app/slots/overbooking": "OVERBOOKING_SLOTS",

  //Rota Management
  "app/rota": "ROTA",
  "/app/rota/shift-details": "SHIFT_DETAILS",
  "/app/rota/shift-edit": "SHIFT_EDIT",
  "/app/rota/shift-add": "SHIFT_ADD",
  "/app/rota/rota-view": "ROTA_VIEW",
  "/app/rota/rota-error": "ROTA_ERROR",
  "/app/rota/remove-slots": "REMOVE_SLOTS",
  "/app/rota/remove-slots/create": "REMOVE_SLOTS",
  "/app/rota/booking-fee": "BOOKING_FEE_CONFIG",
  "/app/rota/booking-fee/create": "BOOKING_FEE_CONFIG",
  // order management module
  "/app/qc-orders": "ORDER_MANAGEMENT",
  "/app/qc-transfer-order": "QC_TRANSFER_ORDER",

  // Configuration
  "/app/configuration": "CONFIGURATION",
  "/app/configuration/clinic-setup": "CLINIC_SETUP",
  "/app/configuration/clinic-onboard": "CLINIC_SETUP_ONBOARD",
  "/app/configuration/clinic-image-update": "CLINIC_SETUP",
  "/app/configuration/city-setup": "CITY_SETUP",
  "/app/configuration/city-onboard": "CITY_SETUP_ONBOARD",
  "/app/configuration/service-setup": "SERVICE_SETUP",
  "/app/configuration/service-onboard": "SERVICE_SETUP_ONBOARD",
  "/app/configuration/equipment-setup": "EQUIPMENT_SETUP",
  "/app/configuration/equipment-onboard": "EQUIPMENT_SETUP_ONBOARD",
  "/app/configuration/warehouse-setup": "WAREHOUSE_LIST",
  "/app/configuration/warehouse-onboard": "WAREHOUSE_ONBOARD",
  "/app/configuration/store-timing-setup": "STORE_TIMING_SETUP",
  "/app/configuration/pincode-setup": "PINCODE_SETUP",
  "/app/configuration/pincode-onboard": "PINCODE_ONBOARD",
  "/app/configuration/pincode-weather-setup": "PINCODE_WEATHER_SETUP",
  "/app/configuration/home-tile-setup": "HOME_TILE_SETUP",
  "/app/configuration/home-tile-onboard": "HOME_TILE_ONBOARD",
  "/app/configuration/clinic-tag-setup": "CLINIC_TAG_SETUP",
  "/app/configuration/clinic-tag-onboard": "CLINIC_TAG_ONBOARD",
  "/app/configuration/staff-setup": "STAFF_SETUP",
  "/app/configuration/groomer-setup": "GROOMER_SETUP",
  "/app/configuration/groomer-onboard": "GROOMER_SETUP_ONBOARD",
  "/app/configuration/groomer-clinic-mapping": "GROOMER_CLINIC_MAP",
  "/app/configuration/staff-onboarding": "STAFF_ONBOARDING",
  "/app/configuration/staff-onboarding-form": "STAFF_ONBOARDING_FORM",
  "/app/configuration/staff-clinic-mapping": "STAFF_CLINIC_MAP",
  "/app/configuration/paravet-setup": "PARAVET_SETUP",
  "/app/configuration/paravet-onboard": "PARAVET_SETUP_ONBOARD",
  "/app/configuration/paravet-clinic-mapping": "PARAVET_CLINIC_MAP",
  "/app/configuration/staff-onboard": "STAFF_SETUP_ONBOARD",
  "/app/configuration/staff-category-setup": "STAFF_CATEGORY_SETUP",
  "/app/configuration/staff-category-onboard": "STAFF_CATEGORY_SETUP_ONBOARD",

  // Staff Calendar
  "/app/staff-calendar": "STAFF_CALENDAR",
  "/app/configuration/roles-setup": "ROLES_PERMISSION",
  "/app/configuration/roles-onboard": "ROLES_PERMISSION_ONBOARD",

  // Inventory Management
  "/app/inventory": "INVENTORY",
  "/app/inventory/vendors-list": "VENDORS_LIST",
  "/app/inventory/vendor-add": "VENDOR_ADD",
  "/app/inventory/hsn-tax": "HSN_AND_TAX_SETUP",
  "/app/inventory/tax-add": "TAX_ADD",
  "/app/inventory/batch": "BATCH_SETUP",
  "/app/inventory/batch-add": "BATCH_ADD",
  "/app/inventory/manufacture": "MANUFACTURER_SETUP",
  "/app/inventory/manufacture-add": "MANUFACTURER_ADD",
  "/app/inventory/product-list": "PRODUCT_LIST",
  "/app/inventory/product-add": "PRODUCT_ADD",
  "/app/inventory/service-list": "SERVICE_LIST",
  "/app/inventory/service-add": "SERVICE_ADD",
  "/app/inventory/purchase-list": "PURCHASE_LIST",
  "/app/inventory/purchase-add": "PURCHASE_ADD",
  "/app/inventory/goods-done": "GRN_DONE",
  "/app/inventory/pending-goods": "PENDING_GOODS",
  "/app/inventory/stock-incomplete-form": "STOCK_INCOMPLETE_FORM",
  "/app/inventory/inventory-snapshot": "INVENTORY_SNAPSHOT",
  "/app/inventory/doctor-inventory": "DOCTOR_INVENTORY",
  "/app/inventory/good-inventory": "ACTIONS_ON_GOOD_INVENTORY",
  "/app/inventory/bad-inventory": "BAD_INVENTORY_REQUESTS",
  "/app/inventory/order-transfer": "TRANSFER_ORDERS",
  "/app/inventory/transfer-good-inventory": "TRANSFER_GOOD_INVENTORY",
  "/app/inventory/transfer-bad-inventory": "TRANSFER_BAD_INVENTORY",
  "/app/inventory/transfer-orders-list": "TRANSFER_ORDER_READ_ONLY",
  "/app/inventory/transfer-order-details": "TRANSFER_ORDER_DETAILS",
  "/app/inventory/bom-setup": "BOM_SETUP",
  "/app/inventory/bom-onboard": "BOM_ONBOARD",
  "/app/inventory/item-group-setup": "ITEM_GROUP_SETUP",
  "/app/inventory/item-group-onboard": "ITEM_GROUP_ONBOARD",
  "/app/inventory/surge-pricing": "SURGE_PRICING_LIST",
  "/app/inventory/surge-pricing-rule": "SURGE_PRICING_ONBOARD",
  "/app/inventory/surge-price-check": "SURGE_PRICING_PRICE_CHECK",
  "/app/inventory/category-setup": "CATEGORY_SETUP",
  "/app/inventory/category-onboard": "CATEGORY_ONBOARD",
  "/app/inventory/sub-category-setup": "SUB_CATEGORY_SETUP",
  "/app/inventory/sub-category-onboard": "SUB_CATEGORY_ONBOARD",
  "/app/inventory/category-mapping": "CATEGORY_MAPPING",
  "/app/inventory/category-mapping-onboard": "CATEGORY_MAPPING_ONBOARD",
  "/app/inventory/add-inventory": "ADD_INVENTORY",
  "/app/inventory/mrp-update": "MRP_UPDATE",
  "/app/inventory/audit-trail": "AUDIT_TRAIL",
  "/app/inventory/audit-trail-export-csv": "AUDIT_TRAIL_EXPORT_CSV",
  "/app/inventory/clinic-to-doctor-transfer": "AHS_INVENTORY_TRANSFER",
  "/app/inventory/create-doctor-good-inventory": "AHS_CREATE_INVENTORY_TRANSFER",
  // Service Desk
  "/app/service-desk": "SERVICE_DESK",
  "/app/service-desk/issue-list": "SERVECE_DESK_RAISE_ISSUE_LIST",
  "/app/service-desk/raise-issue": "SERVECE_DESK_RAISE_ISSUE",
  //cart management
  "/app/user-cart": "CART_MANAGEMENT",
  "/app/user-cart/cart-list": "CART_LIST",
  "/app/user-cart/invoice-list": "INVOICE_LIST",
  "/app/user-cart/transaction-history": "TRANSACTION_HISTORY",
  "/app/user-cart/credit-note": "CREDIT_NOTE",
  "/app/user-cart/debit-note": "DEBIT_NOTE",
  "/app/user-cart/add-credit": "ADD_CREDIT",
  "/app/user-cart/credit-list": "CREDIT_LIST",
  "/app/user-cart/cart-creation": "CART_CREATION",
  "/app/user-cart/cart-billing": "CART_BILLING",
  "/app/user-cart/cart-billing-offline": "CART_BILLING_OFFLINE_PAYMENT",
  "/app/user-cart/hd-cart": "HD_CART_PAGE",
  "/app/customer/profile/mirror-view": "BILLING_MIRROR_VIEW",
  "/app/accounting": "ACCOUNTING",
  "/app/accounting/refund-request": "REFUND_REQUEST",
  "/app/accounting/finance-summary": "FINANCE_SUMMARY",
  "/app/accounting/daily-revenue-payments": "DAILY_REVENUE_PAYMENTS",
  "/app/accounting/finance-sku-approval": "FINANCE_SKU_APPROVAL",
  "/app/accounting/finance-purchase-order": "FINANCE_PURCHASE_ORDER",
  "/app/accounting/debit-note-request": "DEBIT_NOTE_REQUEST",
  "/app/accounting/payment-details": "UPDATE_PAYMENT_DETAILS",
  "/app/accounting/force-discount": "FORCE_DISCOUNT",
  "/app/accounting/bad-debt": "BAD_DEBT",

  //Day Closing
  "/app/closing": "DAY_CLOSING",
  "/app/closing/day-closing": "CLINIC_CLOSING",
  "/app/accounting/cash-closing": "CASH_CLOSING",

  // Lab Report
  "/app/lab-report": "LAB_REPORT",
  "/app/lab-report/internal": "INTERNAL_LAB_REPORT",
  "/app/lab-report/external": "EXTERNAL_LAB_REPORT",
  "/app/lab-report/incoming": "INCOMING_LAB_REPORT",
  "/app/lab-report-interpretation": "LAB_REPORT_INTERPRETATION",
  "/app/lab-report-interpretation/list": "LAB_REPORT_INTERPRETATION_LIST",

  //Coupon service
  "/app/coupon-service": "COUPON_SERVICE",
  "/app/coupon-service/coupon-creation": "COUPON_SERVICE_CREATION",
  "/app/coupon-service/coupon-list": "COUPON_SERVICE_LIST",

  // Membership Setup
  "/app/membership-setup": "MEMBERSHIP_SETUP",
  "/app/membership-setup/membership-list": "MEMBERSHIP_SETUP_LIST",
  "/app/membership-setup/membership-creation": "MEMBERSHIP_SETUP_CREATION",

  // Membership Extension Setup
  // Access rides on the Membership Setup permissions, so the RBAC action ids are shared.
  "/app/membership-extension": "MEMBERSHIP_SETUP",
  "/app/membership-extension/membership-extension-list": "MEMBERSHIP_SETUP_LIST",
  "/app/membership-extension/membership-extension-creation": "MEMBERSHIP_SETUP_CREATION",

  // Voucher Setup
  "/app/voucher-setup": "VOUCHER_SETUP",
  "/app/voucher-setup/voucher-list": "VOUCHER_SETUP_LIST",
  "/app/voucher-setup/voucher-creation": "VOUCHER_SETUP_CREATION",

  // Gift Setup
  "/app/gift-setup": "GIFT_SETUP",
  "/app/gift-setup/gift-list": "GIFT_SETUP_LIST",
  "/app/gift-setup/gift-creation": "GIFT_SETUP_CREATION",

  // Whitelist Mobile
  "/app/whitelist-mobile": "WHITELIST_MOBILE",
  "/app/whitelist-mobile/onboard": "WHITELIST_MOBILE_ONBOARD",
  "/app/whitelist-mobile/image-generation": "IMAGE_GENERATION",
  "/app/whitelist-mobile/slug-management": "SLUG_MANAGEMENT",

  //Lab Report
  "/app/clinic-lab-report": "CLINIC_LAB_REPORT",
  "/app/clinic-lab-report/lab-partner-onboard": "LAB_PARTNER_ONBOARD",
  "/app/clinic-lab-report/lab-partner-list": "LAB_PARTNER_LIST",
  "/app/clinic-lab-report/lab-partner-clinic-list": "LAB_PARTNER_CLINIC_LIST",
  "/app/clinic-lab-report/lab-partner-clinic-mapping": "LAB_PARTNER_CLINIC_MAPPING",
  "/app/clinic-lab-report/lab-partner-clinic-mapping-l": "LAB_PARTNER_ONBOARDING",
  "/app/tools/call-analysis": "CALL_ANALYSIS",
  "/app/vetic-embed": "VETIC_EMBED",

  // Mappings
  "/app/mappings": "DATA_MAPPINGS",
  "/app/mappings/appointment-cart-item-mapping": "APPOINTMENT_CART_ITEM_MAPPING",
  "/app/mappings/appointment-cart-item-mapping-onboard": "APPOINTMENT_CART_ITEM_MAPPING_ONBOARD",

  // Tiles
  "/app/tiles": "TILES_PAGE",
  "/app/tiles/tiles-configuration": "TILES_CONFIGURATION",
};
export const VIRTUAL_ROUTES_MAPPING = {
  // Virtual Routes
  "/app/slots/available-slots-reschedule": "AVAILABLE_SLOTS_RESCHEDULE",
  "/app/slots/available-slots-cancel": "AVAILABLE_SLOTS_CANCELATION",
  "/app/configuration/clinic-onboard": "CLINIC_SETUP_ONBOARD_EDIT",
  "/app/configuration/service-onboard": "SERVICE_SETUP_ONBOARD_EDIT",
  "/app/configuration/equipment-onboard": "EQUIPMENT_SETUP_ONBOARD_EDIT",
  "/app/configuration/pincode-onboard": "PINCODE_ONBOARD_EDIT",
  "/app/configuration/staff-onboard": "STAFF_SETUP_ONBOARD_EDIT",
  "/app/configuration/staff-category-onboard": "STAFF_CATEGORY_SETUP_ONBOARD_EDIT",
  "/app/configuration/roles-onboard": "ROLES_PERMISSION_ONBOARD_EDIT",
  "/app/patient-waiting-list/cta-action": "ACTION_BUTTON_PWL",
  "/app/at-home-services/cta-action": "ACTION_BUTTON_AT_HOME_SERVICES",
  "/app/inventory/purchase-add-ppi-e": "PRIMARY_PRODUCT_INFORMATION_EDIT",
  "/app/inventory/purchase-add-ppi-r": "PRIMARY_PRODUCT_INFORMATION_READ_ONLY",
  "/app/inventory/purchase-add-invoice-r": "MANAGE_INVOICE_READ_ONLY",
  "/app/inventory/purchase-add-invoice-e": "MANAGE_INVOICE_EDIT",
  "/app/inventory/purchase-add-pi-r": "PRODUCT_INFORMATION_READ_ONLY",
  "/app/inventory/purchase-add-pi-e": "PRODUCT_INFORMATION_EDIT",
  "/app/inventory/purchase-add-manage-invoice": "PO_MANAGE_INVOICE",
  "/app/inventory/add-inventory": "ADD_INVENTORY",
  "/app/inventory/mrp-update": "MRP_UPDATE",
  "/app/inventory/audit-trail": "AUDIT_TRAIL",
  "/app/inventory/audit-trail-export-csv": "AUDIT_TRAIL_EXPORT_CSV",
  "/app/inventory/vetic-embed-cta": "VETIC_EMBED",
  "/app/slots/allow_booking_manual_refund": "ALLOW_BOOKING_MANUAL_REFUND",
  "/app/slots/allow_vc_in_bookings": "ALLOW_VC_IN_BOOKINGS",
  "/app/slots/front-desk-overbooking": "FRONT_DESK_OVERBOOKING",
  "/app/slots/ahs-booking-link": "AHS_BOOKING_LINK",
  "/app/slots/edit-booking-permision": "EDIT_BOOKING_COMMENT_PERMISION",
  "/app/service-desk/raise-issue": "SERVECE_DESK_RAISE_ISSUE",
  "/app/service-desk/raise-list": "SERVECE_DESK_RAISE_ISSUE_LIST",
  "/app/configuration/city-onboard": "CITY_SETUP_ONBOARD_EDIT",
  "/app/mappings/appointment-cart-item-mapping-onboard": "APPOINTMENT_CART_ITEM_MAPPING_EDIT",
  "/app/customer/profile/vms-support": "CUSTOMER_SUPPORT",
  // "/app/inventory/bom-onboard": "BOM_SETUP_ONBOARD_EDIT",
  "/app/user-cart": "CART_MANAGEMENT",
  "/app/user-cart/cart-list": "CART_LIST",
  "/app/user-cart/cart-creation": "CART_CREATION",
  "/app/user-cart/cart-billing": "CART_BILLING",
  "/app/user-cart/cart-billing-offline": "CART_BILLING_OFFLINE_PAYMENT",
  "/app/user-cart/hd-cart": "HD_CART_PAGE",
  "/app/customer/profile/mirror-view": "BILLING_MIRROR_VIEW",
  "/app/user-cart/invoice-list": "INVOICE_LIST",
  "/app/user-cart/transaction-history": "TRANSACTION_HISTORY",
  "/app/user-cart/credit-note": "CREDIT_NOTE",
  "/app/user-cart/debit-note": "DEBIT_NOTE",
  "/app/user-cart/add-credit": "ADD_CREDIT",
  "/app/user-cart/credit-list": "CREDIT_LIST",
  "/app/coupon-service": "COUPON_SERVICE",
  "/app/coupon-service/coupon-creation": "COUPON_SERVICE_CREATION",
  "/app/coupon-service/coupon-list": "COUPON_SERVICE_LIST",
  "/app/membership-setup": "MEMBERSHIP_SETUP",
  "/app/membership-setup/membership-list": "MEMBERSHIP_SERVICE_LIST",
  "/app/membership-setup/membership-creation": "MEMBERSHIP_SETUP_CREATION",
  "/app/membership-extension": "MEMBERSHIP_SETUP",
  "/app/membership-extension/membership-extension-list": "MEMBERSHIP_SETUP_LIST",
  "/app/membership-extension/membership-extension-creation": "MEMBERSHIP_SETUP_CREATION",
  "/app/accounting/payment-details": "UPDATE_PAYMENT_DETAILS",
  "/app/accounting": "ACCOUNTING",
  "/app/accounting/refund-request": "REFUND_REQUEST",
  "/app/accounting/finance-summary": "FINANCE_SUMMARY",
  "/app/accounting/daily-revenue-payments": "DAILY_REVENUE_PAYMENTS",
  "/app/accounting/finance-sku-approval": "FINANCE_SKU_APPROVAL",
  "/app/accounting/finance-purchase-order": "FINANCE_PURCHASE_ORDER",
  "/app/accounting/debit-note-request": "DEBIT_NOTE_REQUEST",
  "/app/whitelist-mobile/image-generation": "IMAGE_GENERATION",
  "/app/accounting/refund-request/cta-action": "REFUND_REQUEST_ACTION_CTA",
  "/app/accounting/bad-debt/upload-cta": "BAD_DEBT_UPLOAD_ACTION",
  "/app/accounting/force-discount/upload-cta": "FORCE_DISCOUNT_UPLOAD_ACTION",
  "/app/accounting/debit-note-request/cta-action": "DEBIT_NOTE_REQUEST_ACTION_CTA",
  "/app/accounting/cash-closing-action": "CASH_SORTES_ACTION",
  "/app/user-cart/add-credit/cta-action": "ADD_CREDIT_ACTION_BUTTON",
  "/app/user-cart/credit-note/cta-action": "CREDIT_NOTE_ACTION_CTA",
  "/app/user-cart/cart-creation/cta-action": "CART_CREATION_ACTION_CTA",
  "/app/customer/profile/customer-details/add-pet/cta-action": "ADD_USER_PERSONA_CTA",
  "/app/user-cart/invoice-list/cta-action": "REFUND_INVOICE_ACTION_CTA",
  "/app/user-cart/invoice-list/cta-action-r": "RETURN_INVOICE_ACTION_CTA",
  "/app/user-cart/invoice-list/cta-action-c": "CANCEL_INVOICE_ACTION_CTA",
  "/app/user-cart/invoice-list/cta-action-rm": "REMOVE_MEMBERSHIP_ACTION_CTA",
  "/app/app/customer/profile/customer-details/vaccination/cta-action-enter-data": "ENTER_DATA_ACTION_CTA",
  "/app/user-cart/invoice-list/cta-action-v": "VIEW_INVOICE_ACTION_CTA",
  "/app/customer/profile/customer-details/appointments/action-cta": "APPOINTMENTS_ACTION_BUTTON",
  "/app/customer/profile/emr-view/cta": "EMR_ACTION_BUTTON",
  "/app/customer/profile/search/cta": "CLINIC_WISE_CUSTOMER_SEARCH",
  "/app/customer/profile/emr-view/ctd": "EMR_DOWNLOAD_BUTTON",
  "/app/customer/profile/emr-view/cte": "EDIT_EMR_BUTTON",
  "/app/customer/profile/emr-view/cta-del": "DELETE_EMR_BUTTON",
  "/app/inventory/purchase-list/cta-del": "PO_DELETE_ACTION_CTA",
  "/app/inventory/purchase-add": "RECEIVE_GOODS_ACTION_CTA",
  "/app/customer/profile/customer-details/certificates": "CERTIFICATES_TAB",
  "/app/customer/profile/customer-details/certificates/action-cta-edit-document": "EDIT_DOCUMENT_ACTION_CTA",
  "/app/customer/profile/customer-details/certificates/action-cta-delete-document": "DELETE_DOCUMENT_ACTION_CTA",
  "/app/customer/profile/customer-details/vaccination/mc": "VACCINATION_HISTORY_MANUAL_ACTION",
  "/app/customer/profile/customer-details/vaccination/ml": "USER_MOBILE_EDIT_ACTION",
  "/app/customer/profile/customer-details/vaccination/md": "USER_MOBILE_DISABLE_ACTION",
  "/app/customer/profile/customer-details/vaccination/ocr": "VACCINATION_HISTORY_OCR_ACTION",
  "/app/hd-cart/cta-action-hd-cart": "HD_CART_CTA",
  "/app/clinic-lab-report/lab-partner-clinic-mapping-l": "LAB_PARTNER_ONBOARDING",

  //Day Closing
  "/app/closing": "DAY_CLOSING",
  "/app/closing/day-closing": "CLINIC_CLOSING",
  "/app/accounting/cash-closing": "CASH_CLOSING",

  //Inventory Snapshot
  "/app/inventory/inventory-snapshot-csv": "INVENTORY_SNAPSHOT_EXPORT_AS_CSV",
  "/app/order-transfer-action": "TRANSFER_ORDERS_ACTION",
  //CONFIGURATION

  "/app/configuration/config": "CONFIGURATION_MODULE",
  "/app/configuration/cta-action": "CLINIC_AND_CITY_SETUP",
  "/app/configuration/cta-action-staff": "STAFF_SETUP_PAGE",
  "/app/configuration/cta-action-rota": "ROTA_SETUP_PAGE",
  "/app/configuration/cta-action-quick": "QUICK_COMM_PAGE",
  "/app/configuration/cta-action-inventory": "INVENTORY_MODULE_PAGE",
  "/app/configuration/cta-action-coupon-membership": "COUPON_MEMBERSHIP_PAGE",
  "/app/configuration/cta-action-white-list": "WHITE_LIST_MOBILE_PAGE",
  "/app/configuration/cta-action-clinic-lab-report": "CLINIC_LAB_REPORT_PAGE",

  //Voucher Setup
  "/app/voucher-setup": "VOUCHER_SETUP",
  "/app/voucher-setup/voucher-list": "VOUCHER_SETUP_LIST",
  "/app/voucher-setup/voucher-creation": "VOUCHER_SETUP_CREATION",

  //Gift Setup
  "/app/gift-setup": "GIFT_SETUP",
  "/app/gift-setup/gift-list": "GIFT_SETUP_LIST",
  "/app/gift-setup/gift-creation": "GIFT_SETUP_CREATION",
};
